<template>
  <div class="dark-box" ref="dark">
    <!-- <span style="position:absolute;">{{viewHeight}}</span> -->
    <transition
      name="dark"
      @before-leave="beforeLeave"
      @enter="enter"
      @after-enter="afterEnter"
      @after-leave="afterLeave"
    >
      <slot></slot>
    </transition>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return { viewHeight: "" };
  },
  methods: {
    beforeLeave(el) {
      let h = getComputedStyle(el).height;
      this.$refs.dark.style.height = h;
      el.style.position = "absolute";
    },
    afterLeave(el) {
      el.style.position = "";
    },
    enter(el) {
      let h = getComputedStyle(el).height;
      // this.viewHeight = h;
      this.$refs.dark.style.height = h;
    },
    afterEnter(el) {
      this.$refs.dark.removeAttribute("style");
    }
  }
};
</script>

<style lang="scss" scoped>
.dark-enter-active {
  // transition timing MUST BE larger then height-animation
  transition: opacity 0.24s ease-out;
}

.dark-leave-active {
  transition: opacity 0.24s ease-out;
}

.dark-enter {
  opacity: 0;
}
.dark-leave-to {
  opacity: 0;
}
.dark-box {
  position: relative;
  overflow: hidden;
  transition: height 0.2s ease-out;
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/darkBox.vue